function PaginationControls({
  pagination,
  perPage,
  onPerPageChange,
  onPreviousPage,
  onNextPage,
  onPageChange,
  position = 'bottom'
}) {
  if (!pagination) return null

  const pageOptions = []
  for (let i = 1; i <= pagination.total_pages; i++) {
    pageOptions.push(i)
  }

  const handlePageSelect = (e) => {
    onPageChange(Number(e.target.value))
  }

  const perPageId = `perPage-${position}`
  const pageSelectId = `pageSelect-${position}`

  return (
    <div className="pagination-controls">
      <div className="pagination-info">
        Page {pagination.current_page} of {pagination.total_pages} ({pagination.total_count} total items)
      </div>
      <div className="pagination-buttons">
        <div className="per-page-selector">
          <label htmlFor={perPageId}>Items per page:</label>
          <select
            id={perPageId}
            value={perPage}
            onChange={onPerPageChange}
            className="per-page-dropdown"
          >
            <option value={1}>1</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="page-selector">
          <label htmlFor={pageSelectId}>Go to page:</label>
          <select
            id={pageSelectId}
            value={pagination.current_page}
            onChange={handlePageSelect}
            className="per-page-dropdown"
          >
            {pageOptions.map((page) => (
              <option key={page} value={page}>
                {page}
              </option>
            ))}
          </select>
        </div>
        <button
          className="btn btn-secondary"
          onClick={onPreviousPage}
          disabled={!pagination.has_prev}
        >
          Previous
        </button>
        <button
          className="btn btn-secondary"
          onClick={onNextPage}
          disabled={!pagination.has_next}
        >
          Next
        </button>
      </div>
    </div>
  )
}

export default PaginationControls
